import { LinearProgress } from "@mui/material";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import RequireAuth from "~/auth/RequireAuth";
import RequireSite from "~/components/RequireSite";
import Forbidden from "~/pages/Forbidden";
import MobileLayout from "~/pages/mobile/MobileLayout";

const OAuthRedirect = lazy(() => import("~/pages/OAuthRedirect"));
const Finish = lazy(() => import("~/pages/mobile/finish"));
const Material = lazy(() => import("~/pages/mobile/material"));
const Retail = lazy(() => import("~/pages/mobile/retail"));
const History = lazy(() => import("~/pages/mobile/history"));

const LazyFallback = <LinearProgress />;

/**
 * `/oauth-redirect` is the PKCE callback and `/forbidden` is public — both render OUTSIDE the auth
 * guards. Every other path mounts the mobile shell (`MobileLayout`) behind `RequireAuth >
 * RequireSite`; the shell's Outlet renders the Finish / Material / Retail feature areas and the
 * Activity (offline history/retry) page. RequireSite enforces that a site/starting-node is chosen
 * before any feature area renders. Inventory access is gated on an authenticated BPF user only — the
 * wsapi server enforces `[Authorize]` plus a BPF tenant guard — so no feature route carries a role
 * check (an authenticated user reaches Finish / Material / Retail).
 */
const Router = () => (
	<Suspense fallback={LazyFallback}>
		<Routes>
			<Route element={<OAuthRedirect />} path="/oauth-redirect" />
			<Route element={<Forbidden />} path="/forbidden" />
			<Route
				element={
					<RequireAuth unauthorizedBehavior="redirect">
						<RequireSite>
							<MobileLayout />
						</RequireSite>
					</RequireAuth>
				}
				path="/mobile"
			>
				<Route element={<Navigate replace to="/mobile/finish" />} path="" />
				<Route element={<Finish />} path="finish/*" />
				<Route element={<Material />} path="material/*" />
				<Route element={<Retail />} path="retail/*" />
				<Route element={<History />} path="history" />
				<Route element={<Navigate replace to="/mobile/finish" />} path="*" />
			</Route>
			<Route element={<Navigate replace to="/mobile/finish" />} path="*" />
		</Routes>
	</Suspense>
);

export default Router;
